module.exports = __webpack_public_path__ + "static/media/student-loan-funds.0aa99313.svg";